module.exports = __webpack_public_path__ + "static/media/BICO.b975c856.png";